var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"chart__connection-path",attrs:{"id":`${_vm.conn.id}-line`,"d":_vm.path,"stroke":_vm.borderColor,"stroke-width":_vm.borderWidth,"marker-end":`url(#${_vm.conn.id}-connection-marker)`}})
}
var staticRenderFns = []

export { render, staticRenderFns }